define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/table/New"
], function(declare,xml,New) {

	return declare(New, {

		toWriterRequest: function(/*FormData?*/fd) {
			var call = this.inherited(arguments);
			call.addParameter("Subtype", xml.ATTR_REF, this.widget.urlSecondaryType);
			return call;
		}
	});
});